import useScreenWidth from './useScreenWidth';
import { SCREENS } from 'tailwind/consts';

function useMobileLayout() {
  const screenWidth = useScreenWidth();

  return screenWidth < SCREENS['lg'];
}

export default useMobileLayout;
